import PropTypes from 'prop-types';
import React, { Fragment, PureComponent } from 'react';

import StickerIcon from 'components/icons/Sticker';

const styles = {
  sticker: {
    position: 'absolute',
    top: -30,
    right: -30,
    width: 100,
    height: 100,
  },
  stickerLabel: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#FFF',
    fontWeight: 'bold',
    fontSize: 12,
    position: 'absolute',
    top: 0,
    right: 0,
    width: 60,
    height: 60,
  },
  stickerText: {
    transform: 'rotate(45deg)',
    textAlign: 'center',
  },
};

export default class CardSticker extends PureComponent {
  static propTypes = {
    backgroundColor: PropTypes.string.isRequired,
    children: PropTypes.node,
    label: PropTypes.string,
    labelStyle: PropTypes.object,
  };
  render() {
    const { backgroundColor, children, label, labelStyle } = this.props;
    return (
      <Fragment>
        <StickerIcon color={backgroundColor} style={styles.sticker} />
        <div style={{ ...styles.stickerLabel, ...labelStyle }}>
          {label && <span style={styles.stickerText}>{label}</span>}
          {children}
        </div>
      </Fragment>
    );
  }
}
